import { Link } from "react-router-dom";
import BrandLogo from "@/components/feature/BrandLogo";
import { siteInfo } from "@/lib/videoData";

const footerGroups = [
  {
    title: "内容导航",
    links: [
      { label: "全部电影", to: "/category/movie" },
      { label: "热门剧集", to: "/category/tv" },
      { label: "精选综艺", to: "/category/variety" },
      { label: "搜索影片", to: "/search" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容合作", to: "/about" },
      { label: "版权声明", to: "/about" },
      { label: "意见反馈", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-primary-950 text-background-200">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1.2fr]">
          <div>
            <BrandLogo tone="light" />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300/85">
              糖豆视频专注影视综艺内容导览，收录电影、电视剧与综艺的完整资料与更新信息，帮助你在海量内容里更快找到今晚想看的那一部。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[
                { icon: "ri-weibo-fill", label: "微博" },
                { icon: "ri-wechat-fill", label: "微信" },
                { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
                { icon: "ri-youtube-fill", label: "YouTube" },
              ].map((item) => (
                <span
                  key={item.label}
                  title={item.label}
                  className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-900 text-background-200 transition-colors hover:bg-primary-800 hover:text-accent-300"
                >
                  <i className={`${item.icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          {footerGroups.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-semibold text-background-50">{group.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-300/80 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-300/85">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-accent-400" />
                <a href={`mailto:${siteInfo.email}`} className="break-all transition-colors hover:text-accent-300">
                  {siteInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-base text-accent-400" />
                <span>{siteInfo.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-base text-accent-400" />
                <span className="leading-relaxed">{siteInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800/80 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {siteInfo.since}-2026 糖豆视频 Tangdou TV · 本站内容为演示示例，不提供真实影片播放</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-sm text-accent-400" />
              内容合规审核
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-customer-service-2-line text-sm text-accent-400" />
              7×24 小时支持
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}